module.exports = __webpack_public_path__ + "static/media/login-oauth-loading-monsters.ca55ae71.png";